import React, { useEffect, useState } from "react";
import { ReactComponent as SearchIcon } from "../../../../assets/svg/search.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";
import CalendarModel from "../../LoginLogs/CalendarModal";
import { Popup } from "semantic-ui-react";
import { ReactComponent as FilterIcon } from "../../../../assets/svg/filter.svg";
import moment from "moment";
import Button from "semantic-ui-react/dist/es/elements/Button/Button";
import { ReactComponent as DownloadIcon } from "../../../../assets/svg/downloads.svg";
import { downloadCSVData } from "../../../MainContent/Dashboard/Charts/utils";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as ResetIcon } from "../../../../assets/svg/refresh.svg";
import { updateFilters } from "../../../../actions/userActivityLogsAction";

const Header = (props) => {
    const { setSearchText, searchText, showFilters, setShowFilters, userActivityLogsList, userTimeZone, pages } = props;
    // const startDate = moment(duration.startDate).utc().format();
    // const endDate = moment(duration.endDate).utc().format();
    const isCSVDownloadDisabled = !userActivityLogsList || userActivityLogsList?.length === 0;
    const users = useSelector((state) => state.userActivityLogsReducer.companyUsers);
    const userActivityListLoading = useSelector((state) => state.userActivityLogsReducer.userActivityListLoading);

    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (isLoading && !userActivityListLoading) setIsLoading(false);
    }, [userActivityListLoading]);

    const downloadCSV = () => {
        if (isCSVDownloadDisabled) return;

        let fileName = "Activity Logs";
        let downLoadingData = [];
        downLoadingData.push(["Name", "Date", "Module", "Activity"]);

        userActivityLogsList?.forEach((ele) => {
            const date = moment.utc(ele.date).tz(userTimeZone).format("YYYY-MM-DD HH:mm:ss");
            const user = users[ele.lite_id];

            downLoadingData.push([user?.name || "User", date, ele.module, ele.content]);
        });

        downloadCSVData(downLoadingData, fileName);
    };

    const resetFilters = async () => {
        setIsLoading(true);
        dispatch(updateFilters({}));
    };

    return (
        <>
            <div className="user-activity-div-header">
                <div className="user-activity-div-header-left">
                    <p> Activity Logs</p>
                </div>
                <div className="user-activity-div-header-loginlist-count">
                    <p style={{ color: "#1f2e3d" }}>
                        {/* {this.state.loginglogsListSearchtext != "" ? this.state.list : this.props.pages} */}
                        Showing {props.resultsLength} of {pages}
                        <span style={{ marginLeft: "4px" }}>Records</span>
                    </p>
                </div>

                <div className="user-activity-div-header-right">
                    <div className="user-activity-search">
                        <span className="user-activity-search-icon">
                            <SearchIcon />
                        </span>
                        <input type="text" onChange={(e) => setSearchText(e.target.value)} placeholder="Search" value={searchText} />

                        {searchText.length !== 0 && (
                            <span className="clear-icon" onClick={() => setSearchText("")}>
                                <span>
                                    <CloseIcon />
                                </span>
                            </span>
                        )}
                    </div>
                    <Button className="activity-logs-download-csv logs-download_step1" onClick={downloadCSV} disabled={isCSVDownloadDisabled}>
                        Download CSV
                        <span>
                            <DownloadIcon />
                        </span>
                    </Button>

                    <div className="selectdates activity-logs">
                        {/* <CalendarModel
                            // start={props.duration.startDate}
                            // end={props.duration.endDate}
                            // start={startDate}
                            // end={endDate}
                            onValueChange={(selectedDates) => {
                                // this.setState({ date: selectedDates, currentPage: 1, showlCalender: true });
                            }}
                            onModalClose={(selectedDates) => {
                                // console.log("close", selectedDates);
                                // selectedDates.length > 0 && this.props.fetchuser-activityList(...selectedDates, 0);
                                props.handleDateConfig(selectedDates);
                            }}
                            date={[startDate, endDate]}
                            smpCalender
                            // date={[props.duration.startDate, props.duration.endDate]}
                        /> */}
                    </div>

                    <Popup
                        trigger={
                            <div className={`reset__icon ${isLoading ? "loader" : ""}`} onClick={resetFilters}>
                                <ResetIcon />
                            </div>
                        }
                        content="Reset Filters"
                        position="top center"
                        size="mini"
                        inverted
                        className="skiptranslate"
                    />

                    <Popup
                        trigger={
                            <div className={`filterIcon ${showFilters ? "active" : ""} filter-icon_step1`} onClick={() => setShowFilters(!showFilters)}>
                                <FilterIcon />
                            </div>
                        }
                        content="Filters"
                        position="left center"
                        size="mini"
                        inverted
                        className="skiptranslate"
                    />
                </div>
            </div>
        </>
    );
};

export default Header;
